<template>
    <div>
        <vue-good-table mode="remote" @on-page-change="onPageChange" @on-sort-change="onSortChange"
            @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange" :totalRows="table.total_records"
            :isLoading.sync="table.isLoading" :pagination-options="{
          enabled: true,
          dropdownAllowAll: false,
          perPageDropdown: [10, 25, 50, 100],
        }" :columns="table.columns" :rows="table.rows">
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'action'">
                    
                    <router-link :to="'/outgoing/detail?id=' + props.row.id">
                        <a class="btn btn-sm  btn-primary text-white margin5">Detail</a>
                    </router-link>
                    
                    
                    <a v-on:click="resendOutgoing(props.row.id)" v-if="props.row.status == 'gagal'"  class="btn btn-sm btn-warning text-white margin5">
                        Kirim Ulang
                    </a>
                    
                    <a v-on:click="deleteOutgoing(props.row.id)" class="btn btn-sm  btn-danger text-white margin5">
                        Hapus
                    </a>
                </span>
                <span v-else-if="props.column.field == 'text'">
                        {{ cutString(props.row.text) }}
                        <div v-if="props.row.file">
                            <br>
                            <div class="card">
                                <div class="card-body">
                                    <center>
                                        <b>Document</b>
                                        <br>
                                        <a :href="props.row.file" target="_blank"> Open File </a>
                                    </center>
                                </div>
                            </div>
                        </div>
                </span>
                <span v-else-if="props.column.field == 'jadwal'">
                    {{ convertDateToLocal(props.row.jadwal) }}
                </span>
                <span v-else-if="props.column.field == 'status'">
                    <span v-if="props.row.status == 'Terkirim'" class="badge badge-success">Terkirim</span>
                    <span v-else-if="props.row.status == 'Dalam Antrian' || props.row.status == 'Menunggu Jadwal'"
                        class="badge badge-warning text-white">Dalam Pengiriman</span>
                    <span v-else-if="props.row.status == 'dijadwalkan'"
                        class="badge badge-secondary text-white">Menunggu Jadwal</span>
                    <span v-else-if="props.row.status == 'menunggu device terkoneksi'"
                        class="badge badge-warning text-white">Menunggu Device Terkoneksi</span>
                    <span v-else-if="props.row.status == 'Gagal'" class="badge badge-danger" :title="props.row.keterangan">Gagal</span>
                </span>
                <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                </span>
            </template>
        </vue-good-table>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        data() {
            return {
                table: {
                    total_records: 100,
                    isLoading: true,
                    columns: [{
                            label: "Device",
                            field: "device.name",
                            filterOptions: {
                                enabled: true,
                            },
                            sortable: false,
                            width: "10%",
                        },
                        {
                            label: "Tujuan",
                            field: "to",
                            filterOptions: {
                                enabled: true,
                            },
                            sortable: false,
                            width: "10%",
                        },
                        {
                            label: "Pesan",
                            field: "text",
                            filterOptions: {
                                enabled: true,
                            },
                            sortable: false,
                            width: "35%",
                        },
                        {
                            label: "Jadwal",
                            field: "jadwal",
                            filterOptions: {
                                enabled: true,
                            },
                            sortable: false,
                            width: "15%",
                        },
                        {
                            label: "Status",
                            field: "status",
                            filterOptions: {
                                enabled: true,
                            },
                            sortable: false,
                            width: "10%",
                        },
                        {
                            label: "Action",
                            field: "action",
                            sortable: false,
                            width: "20%",
                        },
                    ],
                    rows: [],
                    // serverParams: {
                    //     nextKey: null
                    // },
                    serverParams: {
                        columnFilters: {},
                        sort: [{
                            field: "",
                            type: "",
                        }, ],
                        page: 1,
                        limit: 10,
                    },
                },
            };
        },
        props: ['dateFilter'],
        mounted() {
            this.fn = () => {
                this.loadItems();
            }
            this.$root.$on("refresh_table", this.fn);
            this.loadItems();
        },
        watch: {
            'dateFilter' : {
                handler(){
                    this.loadItems();
                },
                deep: true
            },
        },
        beforeDestroy() {
            this.$root.$off("refresh_table", this.fn);
        },
        methods: {
            cutString(string){
                if(string == null || string == "") return ""
                
                if(string.length > 40){
                    string = string.slice(0, 40) + "..."
                }

                return string
            },
            convertDateToLocal(date) {
                // console.log(date)
                return moment(date).utcOffset(this.$store?.state?.auth?.user?.timezone).format("YYYY-MM-DD HH:mm:ss")
            },
            async deleteOutgoing(id) {
                const ok = await this.$confirm({
                    title: 'Hapus Pesan',
                    message: 'Yakin ingin menghapus pesan keluar ini?',
                    confirmText: 'Hapus',
                })
                if (!ok) return

                try {
                    let response = await this.$store.dispatch("outgoing_delete", {
                        id: id
                    });
                    this.loadItems();
                    this.$toast.success(response.data.message);
                } catch (err) {
                    this.$toast.error("Server error");
                }
            },
            async resendOutgoing(id){
                try {
                    let response = await this.$store.dispatch("outgoing_resend", {
                        message_id: parseInt(id)
                    });
                    this.loadItems();
                    this.$toast.success(response.data.message);
                } catch (err) {
                    this.$toast.error("Server error");
                }
            },
            updateParams(newProps) {
                this.table.serverParams = Object.assign({},
                    this.table.serverParams,
                    newProps
                );
            },
            onPageChange(params) {
                this.updateParams({
                    page: params.currentPage
                });
                this.loadItems();
            },
            onPerPageChange(params) {
                this.updateParams({
                    limit: params.currentPerPage
                });
                this.loadItems();
            },
            onSortChange(params) {
                this.updateParams({
                    sort: [{
                        type: params.sortType,
                        field: this.table.columns[params.columnIndex].field,
                    }, ],
                });
                this.loadItems();
            },
            onColumnFilter(params) {
                this.updateParams(params);
                this.loadItems();
            },
            async loadItems() {
                this.table.isLoading = true
                try {
                    let response = await this.getFromServer(this.table.serverParams);
                    this.table.total_records = response.data.data.total_records;
                    let outgoing = response.data.data.outgoings;
                    for (let i = 0; i < outgoing.length; i++) {
                        if(outgoing[i].message_type == "button"){
                            let parse = JSON.parse(outgoing[i].data)
                            outgoing[i].parsedButton = parse
                            outgoing[i].footer = parse?.[0].footer
                        }else if(outgoing[i].message_type == "list"){
                            let parse = JSON.parse(outgoing[i].data)
                            outgoing[i].parsedList = parse
                        }
                    }
                    this.table.rows = outgoing
                } catch (err) {
                    console.log(err)
                    this.$toast.error("Too many request");
                }
                this.table.isLoading = false
            },
            async getFromServer(param) {
                return await this.$store.dispatch("outgoing_list", {
                    start: this.dateFilter[0],
                    end: this.dateFilter[1],
                    ...param
                });
            },
        },
    };
</script>

<style scoped>
    .margin5 {
        margin: 5px;
    }
</style>
